// Safari only gained the unprefixed Fullscreen API on desktop in 16.4, and not at all on iPhone, so
// every call goes through the prefixed name as a fallback.
export const FULLSCREEN_CHANGE_EVENTS = ['fullscreenchange', 'webkitfullscreenchange'];

export function isFullscreenSupported(element) {
    return Boolean(element && (element.requestFullscreen || element.webkitRequestFullscreen));
}

export function getFullscreenElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
}

export function isElementFullscreen(element) {
    return Boolean(element) && getFullscreenElement() === element;
}

export async function enterElementFullscreen(element) {
    if (element.requestFullscreen)
        return element.requestFullscreen();

    return element.webkitRequestFullscreen();
}

export async function exitFullscreen() {
    if (document.exitFullscreen)
        return document.exitFullscreen();

    return document.webkitExitFullscreen();
}

export async function toggleElementFullscreen(element) {
    if (isElementFullscreen(element))
        return exitFullscreen();

    return enterElementFullscreen(element);
}
